
const digest = '08d66bdd92d64e692a2144964ed42e7a7b70d9d7c528a5720c5438aaf7223a2a';
const classes = {"wrapper":"_wrapper_ghqli_1","title":"_title_ghqli_8","item":"_item_ghqli_13","itemTitle":"_itemTitle_ghqli_20","bubble":"_bubble_ghqli_25"};
const css = `._wrapper_ghqli_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

._title_ghqli_8 {
  font-size: 12px;
  color: #9ea0a5;
}

._item_ghqli_13 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 9px;
}

._itemTitle_ghqli_20 {
  font-size: 12px;
  color: #3e3f42;
}

._bubble_ghqli_25 {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-right: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  